<script>

    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

</script>

<style>

    .faq-con {
        position: fixed;
        max-width: 600px;
        top: 1vh;
        left: 50%;
        max-height: 98vh; 
        transform: translate(-50%, 0%);
        border: 2px solid black;
        padding: 10px;
        background-color: white;
        /* pointer-events: auto; */
        z-index: 10000;
        box-sizing: border-box;
        overflow-y: scroll;
  
    }

    @media (max-width: 900px) {
        .faq-con {
            left: 2vw;
            width: 96vw;
            transform: unset;
            box-sizing: border-box;
        }
    }

    .faq-header {
        display: flex;
        justify-content: space-between;
    }

    .faq-title {
        font-size: 32px;
        font-weight: 700;
    }

    .faq-close {
        cursor: pointer;
    }

    .faq-body {
        
    }

    .faq-item {
        /* border-bottom: 1px solid #D9D9D9; */
    }

    .faq-q {
        font-weight: 700;
    }

</style>

<div class='faq-con'>

    <div class='faq-header'>
        <div class='faq-title'>
            FAQs 
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class='faq-close' on:click={(e) => dispatch('close-faq')}>
            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 26 26" width="26px" height="26px"><path d="M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z"/></svg>
        </div> 
    </div>

    <div class='faq-body'>

        <div class='faq-item'>
            <div class='faq-q'><p>Where is the data from?</p></div>
            <div class='faq-a'>
                <p>Basically, we've matched Tube stations to postcode rent data.</p>
                <p>We started off by taking a <a href="https://www.ons.gov.uk/economy/inflationandpriceindices/adhocs/2052privaterentalmarketinlondonapril2023tomarch2024">yearly dataset</a> published by the UK's Office for National Statistics (ONS), which breaks down London rents by postcode district. We've then figured out in which postcode district each Tube station is located.</p>
                <p>For example, Clapton Overground station has postcode E5 9JP — so it's in the E5 postcode district. We've linked it to E5 in the ONS dataset, which found that the average rent for one-bedroom flats in the area was £1,400 in the year to March 2024.</p>
                <p>Also, we've used the median rent in every postcode district, not the mean, to avoid skewing things by extreme cases.</p>
            </div>
        </div>
        <div class='faq-item'>
            <div class='faq-q'>Why do some stations say 'not enough data'?</div>
            <div class='faq-a'>
                <p>For some London postcodes, the ONS couldn't find enough examples of properties actually being rented. So the ONS redacted the data, giving blank values rather than a number based on a dodgy sample size.</p> 
                <p>As you can tell by the map, these are mainly postcodes in central London — Oxford Circus, Westminster, Piccadilly Circus, etc.</p>
                <p>Our best guess is that there just simply aren't that many Londoners actually renting in those locations.</p>
                <p>Related: this issue of 'not enough data' is why we've focused on one-bedroom flats — that's the flat type with the best coverage across all of London.</p>
            </div>
        </div>
        <div class='faq-item'>
            <div class='faq-q'>Why do some stations have the same rent figures?</div>
            <div class='faq-a'>
                <p>That'll most likely be because they lie in the same postcode district.</p>
                <p>Postcode districts give us more localised data than say borough-wide figures — but they aren't perfect, and multiple stations with likely different levels of local rent will be grouped together.</p>
            </div>
        </div>
        <div class='faq-item'>
            <div class='faq-q'>Who are you guys?</div>
            <div class='faq-a'>
                <p>We're <i>London Spy</i>, a newsletter for Londoners publishing round-ups, features, investigations and special projects about life in the capital.</p>
                <p>We started the <i>Spy</i> because we think London's local media is in big trouble, and needs a new publication to bring quality back. We're reader-funded, because we think ad-based local news just isn't any good.</p>
                <p>You can <a href="https://www.thelondonspy.co.uk/">sign up the <i>Spy</i> at our website here</a>. Get in touch by emailing us at <a href="mailto:londonspy@substack.com">londonspy@substack.com</a>.</p>
            </div>
            
        </div>

    </div>

</div>